import { createContext } from "react";

const ShowDashboardContext = createContext();

export default ShowDashboardContext;
